import findUrl from '../../utils/findUrl';
import deconstructLocation from '../../utils/deconstructLocation';
import slugify from '../../utils/slugify';
import { CATEGORY_REDIRECTS, SUBURB_REDIRECTS } from '../../constants';

const getInvalidParamsRedirect = (params, query) => {
  if (!params) return false;
  if (!query) return false;

  const { what } = query || {};
  const { categoryName } = params || {};

  if (!categoryName && !what) return '/';
  return false;
};

const getLegacyRedirect = params => {
  if (!params) return false;

  const legacyParams = ['state', 'region', 'suburb', 'legacySuburbRoute'];

  const legacyUrl = legacyParams.find(param => !!params[param]);
  const isLegacySuburb = legacyUrl === 'legacySuburbRoute';
  const { suburb, state } = deconstructLocation(params.legacySuburbRoute);

  return legacyUrl
    ? findUrl({
        ...params,
        keyword: params.categoryName,
        state: isLegacySuburb ? state : params.state,
        // eslint-disable-next-line no-nested-ternary
        suburb: suburb
          ? isLegacySuburb
            ? suburb
            : params.suburb
          : SUBURB_REDIRECTS[params.region] || params.region,
      })
    : false;
};

const categoryRedirects = params => {
  if (!params) return false;

  const { categoryName = '' } = params;
  const redirectCat = CATEGORY_REDIRECTS[categoryName];

  return redirectCat
    ? findUrl({ keyword: redirectCat, suburb_url: params.slug })
    : false;
};

const getSuburbRedirect = params => {
  if (!params) return false;
  const redirect = SUBURB_REDIRECTS[params.slug];
  return redirect
    ? findUrl({ keyword: params.categoryName, suburb_url: redirect })
    : false;
};

const getEmptyDataRedirect = (params, data) => {
  if (!data) return false;
  if (!params) return false;

  const { data: listData } = data || {};
  const { categoryName, slug } = params || {};
  const { suburb, state } = deconstructLocation(slug);

  if (listData && !listData.length && categoryName && suburb)
    return `/search?what=${slugify(categoryName)}&where=${slugify(
      suburb
    )},${slugify(state)}`;

  return false;
};

const categorySearchRedirect = (params, data) => {
  if (!data) return false;
  if (!params) return false;

  const { links } = data || {};
  const { meta } = links || {};
  const { category, location } = meta || {};
  const { categoryName, slug } = params || {};
  const { url_name: locationSlug } = location || {};
  const { suburb, state } = deconstructLocation(slug);

  if (slug && locationSlug && locationSlug !== slug) {
    return findUrl({
      keyword: params.categoryName,
      suburb_url: locationSlug,
    });
  }

  if (
    categoryName &&
    ((categoryName && !category) ||
      slugify(category, /[’]/, '-') !== slugify(categoryName))
  ) {
    return `/search?what=${slugify(categoryName)}&where=${slugify(
      suburb
    )},${slugify(state)}`;
  }
  return false;
};

const redirects = (params, query, data) => {
  const redirectArray = [
    getInvalidParamsRedirect(params, query),
    getLegacyRedirect(params),
    categoryRedirects(params),
    getSuburbRedirect(params),
    getEmptyDataRedirect(params, data),
    categorySearchRedirect(params, data),
  ];

  return redirectArray.find(url => url);
};

export default redirects;
